import React, { Component } from 'react';
// import { withRouter } from 'react-router-dom';
import { useParams, useNavigate } from 'react-router-dom';

import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth,scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl, mediaUrl} from'../Config/Config';
import axios from 'axios';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
	
	return (
		<WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
		/>
	);
};

class Edit extends Component {

	constructor(props)
	{
		CheckAuth();
		super(props);	
		
	    const advisoryid = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;
		this.state = {
            advisoryid: advisoryid,
			selLinkToOption:'',
			selLinkToValue:'',
			selLinkToLabel:'',		
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'active',				

			name: '',
			priority: '',			
			ai_description: '',			
			editid:0,
		};
		var qs = require('qs');
		var catid = this.state.advisoryid;

		axios.get(apiUrl+"advisorydropdown/listdetail?id="+catid).then(res => {			
			if(res.data.advisorylist.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
				this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
			}	
			// link_to dropdown (IMPORTANT FIX)
			const linkToOptions = lang.common.advisory_dropdown_option;
			const selectedLinkTo = linkToOptions.find(
				opt => opt.value === res.data.advisorylist.link_to
			);					
			this.setState({selLinkToOption: selectedLinkTo});
			this.setState({  selLinkToValue : res.data.advisorylist.link_to, name : res.data.advisorylist.name, priority : res.data.advisorylist.priority, ai_description : res.data.advisorylist.ai_description, editid:1});
		}); 

		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);
		this.onChangeHandler = this.onChangeHandler.bind(this);
		this.handleOptionChange = this.handleOptionChange.bind(this);

    }

    handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };
	handleOptionChange = selLinkToOption => {
        this.setState({selLinkToOption})
        this.setState({  selLinkToLabel : selLinkToOption.label, selLinkToValue : selLinkToOption.value, selSubmenuFunc : selLinkToOption.func});
   	};
   	handleInputChange(event) {
		const {name, value} = event.target;      
		this.setState({
			[name]: value
		});      		
		if(name === 'loggedIn'){
			this.setState({loggedInChecked: !this.state.loggedInChecked});
		}	
    }
	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		const extension = file.name.split('.').pop();
		reader.onloadend = () => {
		  this.setState({
			image_name: file.name,
			image_preview: reader.result,
			image: file,
			fileExtension:extension,editid:0
		  });
		};
		reader.readAsDataURL(file);
	}

	componentDidMount() {
		document.title = PageTitle('Advisory Edit');
    }

	
	handleFormSubmit = () => {
		if(this.validateForm()){ 
			this.setState({Loading:true});
			const config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
				};
			const formPayload = this.state;
			var qs = require('qs');
			var status = '';
			if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
			status =formPayload.selectedOption.value;
			}else{
			status = formPayload.selectedvalue;
			}

			var postObject = {
				admin_id : localStorage.getItem("admin_id"),
				name : formPayload.name,
				link_to : formPayload.selLinkToValue,				
				status:  status,				
				editid:  this.state.editid,				
				priority: formPayload.priority,
				ai_description: formPayload.ai_description,
				id: formPayload.advisoryid,
			
			};
			let formData = new FormData();
			for(let k in postObject) {
			formData.append(k, postObject[k]);
			}		       
			axios.post(apiUrl+"advisorydropdown/edit",formData ).then(res => {
				if(res.data.status === "success"){	
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					setTimeout(
					function() {
						$('.success_message').html(this.props.navigate('/advisorydropdown'));
					}
					.bind(this),
					3000
					);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					
					setTimeout(
					function() {
						$('.success_message').html('');
					}
					.bind(this),
					3000
					);
				}
			});
		}
	}

	validateForm() {
		//const {admin_company_name,admin_fname} = this.state;
		const {selLinkToValue} = this.state;
		let errors = {};
      	let formIsValid = true;
		
		if (!selLinkToValue) {
			formIsValid = false;
			$('.errorselLinkToValue').html('<span class="errorspan">Please fill the field</span>');
		}else if(selLinkToValue){
			$('.errorselLinkToValue').html('');
		}


		this.setState({
			errors: errors
		});
		return formIsValid;
    }

render() {

  	const {selectedOption, selLinkToOption} = this.state;	
    return (
		<div className="wrapper"> 
	
		<Header />
		<MenuSidebar currentpage="advisorydropdown" />  
			<div className="content">	
				<div className="content-wrapper">
					<div class="content-wrapper-before"></div>
					<div className="form-wrapper leaa-admin-head card">
						<div className="success_message"></div>
						<div className="content-wrapper">
							<a href="/advisorydropdown" >Back</a>   
						</div>
						<div className="title">
							<h4>Edit Advisory Dropdown</h4>
						</div>
						<form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data">
							<div className="form-row">
								<div className="form-left">
									<div className="form-group">
										<label>Name<span class="required" style={{ color: "red" }} >* </span> : </label>
										<input type="text" name="name" onChange={this.handleInputChange} className="form-control" value={this.state.name}/>
										<div className="errorname"></div>
									</div>
									<div className="form-group">
										<label>Link to<span class="required" style={{ color: "red" }} > * </span> :</label>
										<Select 
										name="status"
										value={selLinkToOption?selLinkToOption:{ value: '', label: 'Select'}}
										options={lang.common.advisory_dropdown_option} 
										isSearchable = {false}
										onChange={this.handleOptionChange}
										/>
										<div className="errorselLinkToValue"></div>
									</div>
									<div className="form-group">					
										<label>Description:</label>
											<CKEditor
												editor={ ClassicEditor }
												data={this.state.ai_description}
												onReady={ editor => {
													// You can store the "editor" and use when it is needed.
													console.log( 'Editor is ready to use!', editor );
													editor.ui.view.editable.element.style.minHeight = "300px";
												} }
												name="ai_description"
												// onChange={this.handleInputChange}
												onChange={ ( event, editor ) => {
													const data = editor.getData();
													this.setState({ai_description: data});
													editor.ui.view.editable.element.style.minHeight = "300px";
													
												} }
											/>
										<div className="errorai_description"></div>
									</div>
									 
								</div>	
								<div className="form-right">	
									<div className="form-group">
										<label>Priority<span class="required" style={{ color: "red" }} >* </span> : </label>
										<input type="text" name="priority" onChange={this.handleInputChange} className="form-control" value={this.state.priority}/>
										<div className="errorpriority"></div>
									</div>
									
									<div className="form-group">
										<div className="form-group">					
											<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
											<Select 
											name="status"
											value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
											options={lang.common.status_option} 
											isSearchable = {false}
											onChange={this.handleChange}
											/>
										</div> 
									</div>										
									
								</div>										
							</div>		

							<div className="btn-group export">	
								<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true? <span>updating</span>:<span>Submit</span>}
								</button>
							</div>
						</form>
					</div>				
				</div>	
			</div>
		</div>
    );
  }
}

export default (withRouter(Edit));